import {
  Image,
  Text,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerHeader,
  DrawerCloseButton,
  Flex,
  Box,
} from "@chakra-ui/react";
import React, { useEffect } from "react";

export const CheckInScheduleInfoModal = ({ isOpen, onClose }) => {
  return (
    <Drawer placement={"bottom"} onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent
        maxH={"85vh"}
        borderTopRadius="2xl"
        maxW={{ base: "100%", md: "560px" }}
        mx="auto"
        mb={{ md: 8 }}
        borderRadius={{ md: "24px" }}
      >
        <Flex
          mx={3}
          my={4}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Text mr={4} fontSize={"18px"} fontWeight={800}>
            Check In Instructions
          </Text>

          <DrawerCloseButton pos={"relative"} top={0} right={0} />
        </Flex>
        <DrawerBody px={0} pt={0} pb={12}>
          <Text px={4}>
            To make your onboarding easier, we have set check in steps for you
            to follow.
          </Text>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
